import React from 'react'
import '../CSS/contact.css'
import iconTel from '../image/icons/tel.jpg'
import iconMail from '../image/icons/mail.png'

function Contact() {
    return (
        <div className='container' id='contact'>
            <h2>צור קשר</h2>
            <p id='allIcons'>
                <a href="tel:0502116999" ><img className='iconsCon' src={iconTel} alt="tel zimer roni" /> - 050-211-6999</a>
                
                <a href="tel:0527688885" ><img className='iconsCon'  src={iconTel} alt="tel zimer roni" /> - 052-768-8885</a>  
             
                <a href="mailto:g0502116999@gmail.com" ><img className='iconsCon' src={iconMail} alt="" /> - g0502116999@gmail.com</a>
               
            </p>
        </div>
    )
}

export default Contact